import { motion } from 'framer-motion'
import { ChevronRight, Home, ArrowLeft } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

const AdminBreadcrumb = () => {
  const location = useLocation()
  
  // Définir les routes et leurs labels
  const routeLabels = {
    '/admin': 'Dashboard',
    '/admin/banners': 'Gestion des Bannières',
    '/admin/jobs': 'Gestion des Emplois',
    '/admin/gallery': 'Gestion de la Galerie',
    '/admin/applications': 'Gestion des Candidatures',
    '/admin/admins': 'Gestion des Admins',
    '/admin/messages': 'Messages',
    '/admin/settings': 'Paramètres',
    '/admin/data': 'Gestion des Données'
  }

  const currentPath = location.pathname
  const currentLabel = routeLabels[currentPath] || 'Page Inconnue'
  const isDashboard = currentPath === '/admin'

  return (
    <motion.div 
      className="bg-white/80 backdrop-blur-sm border-b border-gray-200 px-6 py-4"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center justify-between">
        {/* Breadcrumb */}
        <div className="flex items-center space-x-2 text-sm text-gray-600">
          <Link 
            to="/admin" 
            className="flex items-center hover:text-blue-600 transition-colors"
          >
            <Home size={16} className="mr-1" />
            Dashboard
          </Link>
          
          {!isDashboard && (
            <>
              <ChevronRight size={16} />
              <span className="text-gray-900 font-medium">{currentLabel}</span>
            </>
          )}
        </div>

        {/* Bouton Retour */}
        {!isDashboard && (
          <Link
            to="/admin"
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowLeft size={16} className="mr-2" />
            Retour au Dashboard
          </Link>
        )}
      </div>
    </motion.div>
  )
}

export default AdminBreadcrumb
